import type { ReactNode } from 'react';

export interface ErrorStateProps {
  /** Was nicht geklappt hat, in Alltagssprache. */
  title?: string;
  /** Der Fehler selbst — Error, Text oder unbekannt. */
  error?: unknown;
  /** Was der Nutzer jetzt tun kann. */
  hint?: ReactNode;
  /** Knopf zum erneuten Versuchen. */
  action?: ReactNode;
}

/**
 * Fehlerzustand.
 *
 * Nennt Ursache UND Ausweg. Ein blosses "Fehler" laesst den Nutzer im
 * Ungewissen, ob er warten, neu laden oder jemanden anrufen soll.
 *
 * Die technische Meldung wird gezeigt, nicht versteckt: sie ist oft das
 * Einzige, womit sich ein Problem melden laesst. Sie steht aber unter der
 * verstaendlichen Zeile, nicht an ihrer Stelle.
 */
export function ErrorState({
  title = 'Das hat nicht geklappt',
  error,
  hint = 'Lade die Seite neu. Bleibt es dabei, stimmt etwas mit der Verbindung zum Server nicht.',
  action,
}: ErrorStateProps) {
  const meldung =
    error instanceof Error ? error.message : typeof error === 'string' ? error : null;

  return (
    <div className="error-state" role="alert">
      <p className="error-state__title">{title}</p>
      <div className="error-state__hint">{hint}</div>
      {meldung && <p className="error-state__detail">{meldung}</p>}
      {action && <div className="error-state__action">{action}</div>}
    </div>
  );
}
